import { render, staticRenderFns } from "./StoreLoginAndRegisterModal.vue?vue&type=template&id=20525371&scoped=true&"
import script from "./StoreLoginAndRegisterModal.vue?vue&type=script&lang=js&"
export * from "./StoreLoginAndRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./StoreLoginAndRegisterModal.vue?vue&type=style&index=0&id=20525371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20525371",
  null
  
)

export default component.exports